/* ============================================================
   JRTRACK PRO CONFIGURATOR (MULTIPLE WATCHES, BANDS + CHARGING)
   Generated by build_multi.py from configurator-bands.html plus
   multi/multi.css and multi/multi.js. Edit those sources and rerun; don't edit this file.
   Same chassis as rivian-jrtrack/configurator.html (the JT5 SE build page):
   identical CSS, identical section/summary/checkout behaviour. What differs:

   1. The stage is photo-first, like the JT5 page: 80 renders cover every
      band x bumper combo (assets/configurator/{band}-{bumper}.webp, 10 x 8).
      Sources were 2560px PNGs from "JTPro Configurator-Batch1"; each is
      cropped to one shared box (so the watch never jumps on a swap) at full
      native resolution and encoded WebP q88. 79 MB became 9.4 MB. The 3D
      viewer stays as an extra for Active-Fit bands with no bumper, since
      the GLB has neither the woven bands nor bumper meshes.
   2. Nothing here is in Shopify yet. Every variant id is null, and every price
      marked PLACEHOLDER is a best-available guess, not a confirmed number.
      Checkout deliberately refuses rather than building a bad cart permalink.
   ============================================================ */

/* ---------- Host config ----------
   A host page (the Shopify section) may set window.JTPRO_CONFIG before this
   script runs. Anything it leaves out keeps the defaults below, so the
   standalone page needs no config at all.
     assetUrl(path)  maps 'configurator/b-none.webp' etc. to a real URL
     prices          { watch, watchCompare, band, stand, standCompare }
                     (numbers, or numeric strings)
     variants        same shape as SHOPIFY_VARIANTS below
     handles         same shape as SHOPIFY_HANDLES below
     livePrices      { variantId: { price, compare } } in dollars, from Shopify */
const HOST = window.JTPRO_CONFIG || {};
const asset = HOST.assetUrl || (path => 'assets/' + path);
function hostPrice(key, fallback) {
  const v = HOST.prices && HOST.prices[key];
  if (v === null || v === undefined || v === '') return fallback;
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : fallback;
}

/* ---------- Prices. Sourced where noted; PLACEHOLDER = needs confirming. ---------- */
let  BASE_PRICE   = hostPrice('watch', 179.99);          // from jrtrack-pro/index.html nav + compare table
let  BASE_COMPARE = hostPrice('watchCompare', null);     // Shopify compare-at when set
let  WATCH_NAME   = (HOST.watchName && String(HOST.watchName).trim()) || 'JrTrack Pro';
const BAND_PRICE      = hostPrice('band', 10.99);        // "From $10.99" (accessories section)
const STAND_PRICE     = hostPrice('stand', 44.99);       // JT5 Launchpad live price
const STAND_COMPARE   = hostPrice('standCompare', 59.99);
/* Display-only: one FREE paid band per watch when the theme offer is on
   (2 watches → 2 free bands, etc.). Leftover slots apply to extra bands.
   Cart still adds bands at full Shopify price for auto-apply discounts. */
const FREE_BAND_OFFER = !!HOST.freeBandOffer;
/* Display-only: one FREE Charging Stand per watch when the theme offer is on.
   Extra stands beyond the first stay paid. Cart still adds at full price. */
const FREE_STAND_OFFER = !!HOST.freeStandOffer;

/* Band lineup carried over from the JT5 SE (the Pro reuses the same band, which
   is why the GLB shares its band-silicone mesh). Confirm the Pro band SKUs. */
/* Swatch hex values are sampled from the renders so each dot matches its photo. */
const COLORS = [
  { id:'b',  name:'Black',   fit:'Active-Fit',  hex:'#1A1A1A', bandPrice:0, face:'orange' },
  { id:'bl', name:'Blue',    fit:'Active-Fit',  hex:'#2E81D8', bandPrice:BAND_PRICE, face:'blue' },
  { id:'g',  name:'Green',   fit:'Active-Fit',  hex:'#3F8A61', bandPrice:BAND_PRICE, face:'green' },
  { id:'p',  name:'Pink',    fit:'Active-Fit',  hex:'#F7A6DA', bandPrice:BAND_PRICE, face:'pink' },
  { id:'t',  name:'Teal',    fit:'Active-Fit',  hex:'#6AD5DE', bandPrice:BAND_PRICE, face:'teal' },
  { id:'bv', name:'Blue',    fit:'Comfort-Fit', hex:'#3B6C87', bandPrice:BAND_PRICE, face:'steelblue' },
  { id:'l',  name:'Violet',  fit:'Comfort-Fit', hex:'#4F4185', bandPrice:BAND_PRICE, face:'purple' },
  { id:'r',  name:'Red',     fit:'Comfort-Fit', hex:'#9A1F22', bandPrice:BAND_PRICE, face:'red' },
  { id:'rb', name:'Rainbow', fit:'Stretch-Fit', hex:'#8A5CD1', bandPrice:BAND_PRICE, face:'orange' },
  { id:'y',  name:'Sunrise', fit:'Stretch-Fit', hex:'#E8823D', bandPrice:BAND_PRICE, face:'orange' },
];

const CHARGING = [
  { id:'standard', title:'Standard Charging Clip', desc:'Magnetic charging clip, included in the box.', price:0 },
  { id:'stand',    title:'Charging Stand',         desc:'Upgrade to the magnetic nightstand dock.',      price:STAND_PRICE, compare:STAND_COMPARE },
];

const state = {
  color:     'b',
  charging:  'standard',
  viewMode:  'watch',    // 'watch' | 'stand'
};

/* ============================================================
   MULTIPLE WATCHES + EXTRAS  (configurator-multi.html)
   Added by build_multi.py on top of the full configurator.

   The single-watch builder is built around one `state`. That stays: `state`
   always mirrors the watch being edited, so the stage, the 3D viewer and the
   section pickers work exactly as before. On top of it:
     watches[]   one build per watch: band, bumper, charging (+ how many
                 stands), clip, name
     extras      add-on quantities that don't belong to a watch:
                 more bands, bumpers and clips
   Every pick is written back to watches[active] by commitWatch().

   It builds on either page: the bands + charging build (the default, since
   screen protectors and the Explorer Clip aren't for sale yet) or the full
   one. HAS_PROTECTORS / HAS_CLIPS switch those parts on when the page has them.
   ============================================================ */
const HAS_PROTECTORS = typeof PROTECTORS !== 'undefined';
const HAS_CLIPS = typeof CLIP_COLORS !== 'undefined';
const protectorOf = id => HAS_PROTECTORS ? PROTECTORS.find(x => x.id === id) : null;
const clipOf = id => HAS_CLIPS && id ? CLIP_COLORS.find(x => x.id === id) : null;
const MAX_WATCHES = 6;
const SAVE_KEY = 'jtpro-multi-build-v1';

let watchSeq = 0;
function newWatch(from) {
  watchSeq += 1;
  return {
    uid: watchSeq,
    name: '',
    color:     from ? from.color     : 'b',
    protector: from ? from.protector : 'none',
    charging:  from ? from.charging  : 'standard',
    standQty:  from ? from.standQty  : 1,     // stands for this watch when charging is 'stand'
    clip:      from ? from.clip      : null,
  };
}
let watches = [newWatch()];
let active = 0;
const extras = { bands: {}, protectors: {}, clips: {} };
const extrasOpen = { bands: false, protectors: false, clips: false };

/* Extra Black bands are sold too, so every band color carries a unit price
   (the watch's own Black band stays free; see COLORS.bandPrice). */
COLORS.forEach(c => { c.unit = BAND_PRICE; c.unitCompare = null; });

function watchLabel(w, i) { return w.name || `Watch ${i + 1}`; }

function commitWatch() {
  const w = watches[active];
  w.color = state.color; w.protector = state.protector || 'none';
  w.charging = state.charging; w.clip = state.clip || null;
  saveBuild();
}
function loadWatch(i) {
  active = i;
  const w = watches[i];
  state.color = w.color; state.charging = w.charging;
  if (HAS_PROTECTORS) state.protector = w.protector;
  if (HAS_CLIPS) state.clip = w.clip;
}

/* ---------- switching, adding, removing ---------- */
function switchWatch(i, opts = {}) {
  if (i === active && !opts.force) return;
  loadWatch(i);
  state.viewMode = 'watch';
  renderColors(); renderCharging();
  if (HAS_PROTECTORS) renderProtectors();
  if (HAS_CLIPS) renderClip();
  updateHeroImage();
  update3dAvailability();
  applyBand3dColor();
  renderWatchUI();
  syncSummary();
  warmBandRow();
  saveBuild();
  const panel = document.getElementById('cfgPanel');
  panel.classList.remove('is-swapping'); void panel.offsetWidth; panel.classList.add('is-swapping');
  setTimeout(() => panel.classList.remove('is-swapping'), 400);
}

function addWatch(copy) {
  if (watches.length >= MAX_WATCHES) { toast(`You can build up to ${MAX_WATCHES} watches here.`); return; }
  watches.push(newWatch(copy ? watches[active] : null));
  switchWatch(watches.length - 1, { force: true });
  const label = watchLabel(watches[active], active);
  toast(copy ? `${label} added with the same build.` : `${label} added. Choose its band below.`);
  scrollToSection('secColor');
}

function removeWatch() {
  if (watches.length < 2) return;
  const at = active, gone = watches[at], label = watchLabel(gone, at);
  watches.splice(at, 1);
  switchWatch(Math.min(at, watches.length - 1), { force: true });
  toast(`${label} removed.`, 'Undo', () => {
    if (watches.length >= MAX_WATCHES) return;
    watches.splice(at, 0, gone);
    switchWatch(at, { force: true });
  });
}

/* Rename in place: the active tab's label becomes a text field. */
function renameWatch() {
  const tab = document.querySelector('.watch-tab.is-active .wt-name');
  if (!tab) return;
  const w = watches[active];
  tab.innerHTML = `<input class="wt-input" maxlength="18" placeholder="e.g. Maya's watch" aria-label="Watch name">`;
  const input = tab.querySelector('input');
  input.value = w.name;
  input.focus(); input.select();
  let done = false;
  const finish = save => {
    if (done) return; done = true;
    if (save) { w.name = input.value.trim(); saveBuild(); }
    renderWatchUI(); syncSummary();
  };
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') finish(true);
    if (e.key === 'Escape') finish(false);
  });
  input.addEventListener('blur', () => finish(true));
  input.addEventListener('click', e => e.stopPropagation());
}

function scrollToSection(id) {
  const el = document.getElementById(id), panel = document.getElementById('cfgPanel');
  if (!el) return;
  const bar = document.getElementById('watchBar');
  const offset = (bar ? bar.offsetHeight : 0) + 28;
  if (isStacked()) {
    // land just under the pinned stack: nav + photo (+ watch bar, via offset)
    const pinned = document.querySelector('nav').offsetHeight + document.querySelector('.img-panel').offsetHeight;
    const top = el.getBoundingClientRect().top + window.scrollY - pinned - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  } else {
    const top = el.getBoundingClientRect().top - panel.getBoundingClientRect().top + panel.scrollTop - offset;
    panel.scrollTo({ top, behavior: 'smooth' });
  }
}

/* ---------- the switcher, the stage strip, the prompt card ---------- */
function bandDot(colorId) {
  const c = COLORS.find(x => x.id === colorId) || COLORS[0];
  const special = c.id === 'rb' ? 'is-rainbow' : c.id === 'y' ? 'is-sunrise' : '';
  return { cls: special, style: special ? '' : `background:${c.hex};` };
}

function renderWatchUI() {
  const multi = watches.length > 1;

  document.getElementById('watchTabs').innerHTML = watches.map((w, i) => {
    const d = bandDot(w.color);
    const p = protectorOf(w.protector);
    const ring = p && p.hex ? ` has-bumper" style="${d.style}--bumper:${p.hex}` : `" style="${d.style}`;
    const on = i === active;
    return `<button class="watch-tab${on ? ' is-active' : ''}" type="button" role="tab" aria-selected="${on}"
              onclick="switchWatch(${i})"><span class="wt-dot ${d.cls}${ring}"></span><span class="wt-name">${escapeHtml(watchLabel(w, i))}</span></button>`;
  }).join('') + (watches.length < MAX_WATCHES
    ? `<button class="watch-tab is-add${multi ? ' is-compact' : ''}" type="button" onclick="addWatch()"
         aria-label="Add a watch" title="Add a watch"><span class="wt-plus">+</span>${multi ? '' : ' Add a watch'}</button>` : '');
  syncTabsScroll(true);

  document.getElementById('watchActions').innerHTML =
      `<button type="button" onclick="renameWatch()">${PENCIL_SVG}Rename</button>`
    + (multi ? `<button type="button" class="is-remove" onclick="removeWatch()">${TRASH_SVG}Remove</button>` : '');

  const strip = document.getElementById('watchStrip');
  strip.hidden = !multi;
  strip.innerHTML = multi ? watches.map((w, i) => `
      <button class="ws-tile${i === active ? ' is-active' : ''}" type="button" onclick="switchWatch(${i})"
              aria-label="Show ${escapeHtml(watchLabel(w, i))}" title="${escapeHtml(watchLabel(w, i))}">
        <img src="${watchSrc(w.color, w.protector)}" alt="" /><span class="ws-num">${i + 1}</span>
      </button>`).join('')
    + (watches.length < MAX_WATCHES ? `<button class="ws-tile is-add" type="button" onclick="addWatch()" aria-label="Add a watch" title="Add a watch">+</button>` : '')
    : '';

  // the card invites the second watch; after that the bar's + button does the job
  document.getElementById('addWatchCard').hidden = multi;
  document.getElementById('awcThumb').src = watchSrc(state.color, state.protector);

  /* The switcher only appears once there's a second watch to switch to. */
  const bar = document.getElementById('watchBar');
  bar.hidden = !multi;
  document.getElementById('cfgPanel').classList.toggle('is-multi', multi);
  syncStageGap();

  document.getElementById('cfgPriceEach').style.display = multi ? '' : 'none';
}

/* Phones: the photo pins under the nav while there are options to preview, then
   leaves with the page at the line under the last option section, so the cart gets
   the whole screen. That is plain CSS sticky, so the browser does it on the
   compositor with no scroll listener (an earlier JS version lagged behind
   momentum scrolling). It needs the photo to sit in the same box as the options,
   #optZone, which ends at that line; on desktop it stays in the left column. */
const STACKED_MQ = window.matchMedia('(max-width: 820px), (max-width: 1080px) and (orientation: portrait)');
function isStacked() { return STACKED_MQ.matches; }
function placeStage() {
  const img = document.querySelector('.img-panel');
  const zone = document.getElementById('optZone');
  const builder = document.querySelector('.builder');
  if (isStacked()) { if (img.parentElement !== zone) zone.insertBefore(img, zone.firstChild); }
  else if (img.parentElement !== builder) builder.insertBefore(img, builder.firstChild);
  document.body.classList.toggle('stage-in-flow', isStacked());
}
/* The photo's bottom margin matches what's pinned under it (see --stage-gap in
   multi.css). Set when the bar shows, hides or resizes; never on scroll. */
function syncStageGap() {
  const bar = document.getElementById('watchBar');
  const gap = bar.hidden ? 0 : bar.offsetHeight + parseFloat(getComputedStyle(bar).marginBottom);
  document.documentElement.style.setProperty('--stage-gap', `${Math.round(gap)}px`);
}
STACKED_MQ.addEventListener('change', () => { placeStage(); syncStageGap(); });
window.addEventListener('resize', syncStageGap);
placeStage();

/* Keep the selected tab in view, and fade the edge while more tabs sit off to the right. */
function syncTabsScroll(revealActive) {
  const row = document.getElementById('watchTabs');
  const tab = row.querySelector('.watch-tab.is-active');
  if (revealActive && tab) {
    const left = tab.offsetLeft - row.offsetLeft, right = left + tab.offsetWidth;
    if (left < row.scrollLeft) row.scrollLeft = left - 8;
    else if (right > row.scrollLeft + row.clientWidth) row.scrollLeft = right - row.clientWidth + 8;
  }
  row.classList.toggle('fade-right', row.scrollLeft + row.clientWidth < row.scrollWidth - 4);
  row.classList.toggle('fade-left', row.scrollLeft > 4);
}
window.addEventListener('resize', () => syncTabsScroll(false));
document.getElementById('watchTabs').addEventListener('scroll', () => syncTabsScroll(false), { passive: true });

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}

/* ---------- Charging Stand quantity: a stepper inside the selected card ----------
   renderCharging() (shared with the single-watch page) draws the two cards; this
   adds a quantity row to the Charging Stand card while it's picked. At 1 the minus
   becomes a trash can, which goes back to the included charging clip. */
const PENCIL_SVG = '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.8 2.7l2.5 2.5L5.8 12.7 2.7 13.3l.6-3.1z"/></svg>';
const TRASH_SVG = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 4.5h11M6.5 4.5V3a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1.5M4 4.5l.7 8.6a1 1 0 0 0 1 .9h4.6a1 1 0 0 0 1-.9l.7-8.6"/></svg>';
let standRowFor = null;   // which watch's stand row is already open, so it only slides in once
function decorateCharging() {
  const i = CHARGING.findIndex(o => o.id === 'stand');
  const card = document.querySelectorAll('#chargingCards .chg-card')[i];
  if (!card || state.charging !== 'stand') { standRowFor = null; return; }
  const q = watches[active].standQty || 1;
  const fresh = standRowFor !== watches[active].uid;
  standRowFor = watches[active].uid;
  card.classList.add('has-qty');
  card.insertAdjacentHTML('beforeend', `
    <div class="chg-qty${fresh ? ' is-new' : ''}" onclick="event.stopPropagation()">
      <span class="chg-qty-label">How many?</span>
      <div class="stepper">
        <button type="button" onclick="bumpStand(-1)" aria-label="${q === 1 ? 'Remove the Charging Stand' : 'One fewer Charging Stand'}">${q === 1 ? TRASH_SVG : '&minus;'}</button>
        <span aria-live="polite">${q}</span>
        <button type="button" onclick="bumpStand(1)" aria-label="One more Charging Stand">+</button>
      </div>
    </div>`);
}
function bumpStand(delta) {
  const w = watches[active];
  const q = (w.standQty || 1) + delta;
  if (q < 1) { w.standQty = 1; pickCharging('standard'); return; }
  w.standQty = Math.min(9, q);
  renderCharging();
  syncSummary();
  saveBuild();
}

/* ---------- extras: "add more" lists under each section ---------- */
const EXTRA_KINDS = {
  bands: {
    el: 'extrasBands', title: 'Add more bands', sub: 'Swap colors whenever they like',
    items: () => COLORS.map(c => ({
      id: c.id, name: c.name, meta: c.fit, hex: c.hex,
      special: c.id === 'rb' ? 'is-rainbow' : c.id === 'y' ? 'is-sunrise' : '',
      price: c.unit, compare: c.unitCompare,
    })),
    line: it => `Band · ${it.name} ${it.meta}`,
    variant: id => SHOPIFY_VARIANTS.bands && SHOPIFY_VARIANTS.bands[id],
  },
  protectors: {
    el: 'extrasProtectors', title: 'Add more screen protectors', sub: 'Keep a backup, or a second color',
    items: () => PROTECTORS.filter(p => p.hex).map(p => ({
      id: p.id, name: p.name, hex: p.hex, price: p.price, compare: p.compare,
    })),
    line: it => `Screen protector · ${it.name}`,
    variant: id => SHOPIFY_VARIANTS.protectors && SHOPIFY_VARIANTS.protectors[id],
  },
  clips: {
    el: 'extrasClips', title: 'Add more Explorer Clips', sub: 'One for every backpack',
    items: () => CLIP_COLORS.map(c => ({
      id: c.id, name: c.name, hex: c.hex, special: c.id === 'glow' ? 'is-glow' : '',
      price: c.price, compare: c.compare,
    })),
    line: it => `Explorer Clip · ${it.name}`,
    variant: id => SHOPIFY_VARIANTS.clips && SHOPIFY_VARIANTS.clips[id],
  },
};

if (!HAS_PROTECTORS) delete EXTRA_KINDS.protectors;
if (!HAS_CLIPS) delete EXTRA_KINDS.clips;
for (const kind of Object.keys(extras)) if (!EXTRA_KINDS[kind]) delete extras[kind];

function extrasCount(kind) { return Object.values(extras[kind]).reduce((a, b) => a + b, 0); }

function priceHint(items) {
  const prices = [...new Set(items.map(it => it.price.toFixed(2)))];
  return prices.length === 1
    ? `$${prices[0]} / each`
    : `from $${Math.min(...items.map(it => it.price)).toFixed(2)} / each`;
}

function stepperHtml(kind, it, q) {
  if (!q) return `<button class="step-add" type="button" aria-label="Add ${escapeHtml(it.name)}" onclick="bumpExtra('${kind}','${it.id}',1)">+</button>`;
  return `<div class="stepper">
      <button type="button" aria-label="Remove one ${escapeHtml(it.name)}" onclick="bumpExtra('${kind}','${it.id}',-1)">&minus;</button>
      <span aria-live="polite">${q}</span>
      <button type="button" aria-label="Add one more ${escapeHtml(it.name)}" onclick="bumpExtra('${kind}','${it.id}',1)">+</button>
    </div>`;
}

function renderExtras(kind) {
  const K = EXTRA_KINDS[kind], el = document.getElementById(K.el);
  if (!el) return;
  const items = K.items(), sel = extras[kind];
  const count = extrasCount(kind);
  const total = items.reduce((s, it) => s + (sel[it.id] || 0) * it.price, 0);
  const summary = count ? `${count} added · +$${total.toFixed(2)}` : `${K.sub} · ${priceHint(items)}`;

  if (K.single) {
    const it = items[0];
    el.innerHTML = `
      <div class="extras-row${count ? ' has-qty' : ''}">
        <span class="extras-plus">${count || '+'}</span>
        <span class="extras-text"><b>${K.title}</b><small>${summary}</small></span>
        ${stepperHtml(kind, it, sel[it.id] || 0)}
      </div>`;
    return;
  }
  const open = extrasOpen[kind];
  el.innerHTML = `
    <button class="extras-toggle${open ? ' is-open' : ''}${count ? ' has-qty' : ''}" type="button"
            aria-expanded="${open}" aria-controls="${K.el}List" onclick="toggleExtras('${kind}')">
      <span class="extras-plus">${count || '+'}</span>
      <span class="extras-text"><b>${K.title}</b><small>${summary}</small></span>
      <svg class="extras-chev" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg>
    </button>
    <div class="extras-list" id="${K.el}List"${open ? '' : ' hidden'}>
      ${items.map(it => {
        const q = sel[it.id] || 0;
        return `<div class="extra-item${q ? ' has-qty' : ''}">
          <span class="extra-dot ${it.special || ''}" style="${it.special && it.special !== 'is-glow' ? '' : `background:${it.hex}`}"></span>
          <span class="extra-name">${escapeHtml(it.name)}${it.meta ? `<small>${it.meta}</small>` : ''}</span>
          <span class="extra-price">$${it.price.toFixed(2)} / each</span>
          ${stepperHtml(kind, it, q)}
        </div>`;
      }).join('')}
    </div>`;
}
function renderAllExtras() { Object.keys(EXTRA_KINDS).forEach(renderExtras); }

function toggleExtras(kind) { extrasOpen[kind] = !extrasOpen[kind]; renderExtras(kind); }

function bumpExtra(kind, id, delta) {
  const q = Math.max(0, Math.min(9, (extras[kind][id] || 0) + delta));
  if (q) extras[kind][id] = q; else delete extras[kind][id];
  renderExtras(kind);
  syncSummary();
  saveBuild();
}

/* ============================================================
   SUMMARY: every watch, then extras, then one total
   ============================================================ */
/* One free paid-band slot per watch. Worn color bands take slots first;
   leftover slots discount extra bands (display-only). */
function freeBandPlan() {
  let left = FREE_BAND_OFFER ? watches.length : 0;
  const wornFree = watches.map(w => {
    const c = COLORS.find(x => x.id === w.color);
    if ((c.bandPrice || 0) > 0 && left > 0) { left -= 1; return true; }
    return false;
  });
  const extraFree = {};
  if (EXTRA_KINDS.bands && left > 0) {
    for (const it of EXTRA_KINDS.bands.items()) {
      const q = extras.bands[it.id] || 0;
      if (!q) continue;
      const n = Math.min(q, left);
      if (n) { extraFree[it.id] = n; left -= n; }
      if (!left) break;
    }
  }
  return { wornFree, extraFree };
}

function watchLines(w, i) {
  const c    = COLORS.find(x => x.id === w.color);
  const prot = protectorOf(w.protector);
  const chg  = CHARGING.find(x => x.id === w.charging);
  const clip = clipOf(w.clip);
  const plan = arguments.length > 2 ? arguments[2] : freeBandPlan();
  const lines = [{ name: WATCH_NAME, price: BASE_PRICE, compare: BASE_COMPARE }];
  if ((c.bandPrice || 0) > 0) {
    const free = !!(plan.wornFree && plan.wornFree[i]);
    lines.push({
      name: `${c.name} ${c.fit} band`,
      price: free ? 0 : c.bandPrice,
      free,
      plus: !free,
      compare: free ? c.bandPrice : c.bandCompare,
    });
  }
  if (prot && prot.price > 0) lines.push({ name: `${prot.name} screen protector`, price: prot.price, plus: true, compare: prot.compare });
  const sq = w.charging === 'stand' ? (w.standQty || 1) : 1;
  if (chg && chg.id === 'stand' && sq > 0 && chg.price > 0) {
    const freeN = FREE_STAND_OFFER ? Math.min(1, sq) : 0;
    const paidN = sq - freeN;
    if (freeN) {
      lines.push({
        name: chg.title + (freeN > 1 ? ` × ${freeN}` : ''),
        price: 0, free: true, plus: false,
        compare: chg.price * freeN,
      });
    }
    if (paidN) {
      lines.push({
        name: chg.title + (paidN > 1 ? ` × ${paidN}` : ''),
        price: chg.price * paidN, plus: true,
        compare: chg.compare != null ? chg.compare * paidN : null,
      });
    }
  } else if (chg && chg.price > 0) {
    lines.push({
      name: chg.title + (sq > 1 ? ` × ${sq}` : ''),
      price: chg.price * sq, plus: true,
      compare: chg.compare != null ? chg.compare * sq : null,
    });
  }
  if (clip)            lines.push({ name: `Explorer Clip · ${clip.name}`, price: clip.price, plus: true, compare: clip.compare });
  return lines;
}

function extraLines(plan) {
  plan = plan || freeBandPlan();
  const lines = [];
  for (const [kind, K] of Object.entries(EXTRA_KINDS)) {
    for (const it of K.items()) {
      const q = extras[kind][it.id] || 0;
      if (!q) continue;
      const freeN = (kind === 'bands' && plan.extraFree[it.id]) ? plan.extraFree[it.id] : 0;
      const paidN = q - freeN;
      if (freeN) {
        lines.push({
          name: K.line(it) + (freeN > 1 ? ` × ${freeN}` : ''),
          price: 0, free: true, plus: false,
          compare: it.price * freeN,
        });
      }
      if (paidN) {
        lines.push({
          name: K.line(it) + (paidN > 1 ? ` × ${paidN}` : ''),
          price: it.price * paidN, plus: true,
          compare: it.compare != null ? it.compare * paidN : null,
        });
      }
    }
  }
  return lines;
}

const sumLines = lines => lines.reduce((s, l) => s + l.price, 0);

function lineHtml(l) {
  const priceStr = l.free
    ? 'FREE'
    : `${l.plus ? '+' : ''}$${l.price.toFixed(2)}`;
  return `<div class="cart-line${l.free ? ' is-free' : ''}">
      <span class="cart-line-name">${escapeHtml(l.name)}</span>
      <span class="cart-line-price">${priceStr}${wasInline(l.compare, l.free ? 0 : l.price)}</span>
    </div>`;
}

function syncSummary() {
  const c    = COLORS.find(x => x.id === state.color);
  const chg  = CHARGING.find(x => x.id === state.charging);

  /* Header: the price of one watch */
  document.getElementById('cfgPrice').textContent = `$${BASE_PRICE.toFixed(2)}`;
  const wasEl = document.getElementById('cfgWas');
  if (BASE_COMPARE != null && BASE_COMPARE > BASE_PRICE) {
    wasEl.textContent = `$${BASE_COMPARE.toFixed(2)}`;
    wasEl.style.display = '';
  } else { wasEl.style.display = 'none'; }

  const discEl = document.getElementById('cfgDiscount');
  if (discEl) {
    if (BASE_COMPARE != null && BASE_COMPARE > BASE_PRICE) {
      const pct = Math.round((1 - BASE_PRICE / BASE_COMPARE) * 100);
      discEl.textContent = pct > 0 ? `${pct}% off` : '';
      discEl.style.display = pct > 0 ? '' : 'none';
    } else {
      discEl.style.display = 'none';
    }
  }

  const plan = freeBandPlan();

  /* Section summaries describe the watch being edited */
  document.getElementById('pickColor').textContent = `${c.name} · ${c.fit}`;
  const bandEl = document.getElementById('bandLabel');
  const bandIsFree = !!(plan.wornFree[active] && (c.bandPrice || 0) > 0);
  if (bandIsFree) {
    bandEl.textContent = 'FREE';
    bandEl.classList.add('is-free');
    bandEl.classList.remove('is-paid');
  } else if ((c.bandPrice || 0) > 0) {
    bandEl.innerHTML = `+$${c.bandPrice.toFixed(2)} / each${wasInline(c.bandCompare, c.bandPrice)}`;
    bandEl.classList.add('is-paid');
    bandEl.classList.remove('is-free');
  } else {
    bandEl.textContent = 'Included';
    bandEl.classList.remove('is-free', 'is-paid');
  }
  const bandWasEl = document.getElementById('bandWas');
  if (bandWasEl) {
    const catalog = (c.bandPrice || 0) > 0
      ? c.bandPrice
      : (COLORS.find(x => x.bandPrice) || {}).bandPrice || BAND_PRICE;
    const showWas = bandIsFree
      || ((c.bandPrice || 0) > 0 && c.bandCompare != null && c.bandCompare > c.bandPrice + 0.001);
    if (showWas && catalog) {
      const wasAmt = bandIsFree
        ? catalog
        : (c.bandCompare != null ? c.bandCompare : catalog);
      bandWasEl.textContent = '$' + Number(wasAmt).toFixed(2);
      bandWasEl.style.display = '';
    } else {
      bandWasEl.style.display = 'none';
    }
  }
  if (HAS_PROTECTORS) {
    const prot = protectorOf(state.protector);
    document.getElementById('pickProtector').textContent = prot.name;
    document.getElementById('protectorPrice').innerHTML = prot.price > 0
      ? `+$${prot.price.toFixed(2)} / each${wasInline(prot.compare, prot.price)}` : '';
  }
  const sq = state.charging === 'stand' ? (watches[active].standQty || 1) : 1;
  document.getElementById('pickCharging').textContent = chg.title + (sq > 1 ? ` × ${sq}` : '');
  const chgEl = document.getElementById('chargingPrice');
  const standFreeN = (FREE_STAND_OFFER && state.charging === 'stand' && chg.price > 0)
    ? Math.min(1, sq) : 0;
  const standPaidN = sq - standFreeN;
  if (chg.price <= 0) {
    chgEl.textContent = 'Included';
    chgEl.classList.remove('is-free', 'is-paid');
  } else if (standFreeN && !standPaidN) {
    chgEl.textContent = 'FREE';
    chgEl.classList.add('is-free');
    chgEl.classList.remove('is-paid');
  } else if (standFreeN && standPaidN) {
    chgEl.innerHTML = `+$${(chg.price * standPaidN).toFixed(2)}${wasInline(
      chg.compare != null ? chg.compare * standPaidN : null, chg.price * standPaidN)}`;
    chgEl.classList.add('is-paid');
    chgEl.classList.remove('is-free');
  } else {
    chgEl.innerHTML = sq > 1
      ? `+$${(chg.price * sq).toFixed(2)}${wasInline(chg.compare != null ? chg.compare * sq : null, chg.price * sq)}`
      : `+$${chg.price.toFixed(2)} / each${wasInline(chg.compare, chg.price)}`;
    chgEl.classList.add('is-paid');
    chgEl.classList.remove('is-free');
  }
  const standWasEl = document.getElementById('standWas');
  if (standWasEl) {
    const standOpt = CHARGING.find(o => o.id === 'stand');
    const catalog = standOpt && standOpt.price;
    const ref = standOpt && standOpt.compare;
    if (standFreeN && catalog) {
      standWasEl.textContent = '$' + Number(catalog).toFixed(2);
      standWasEl.style.display = '';
    } else if (ref != null && chg.price > 0 && ref > chg.price + 0.001) {
      standWasEl.textContent = '$' + Number(ref * sq).toFixed(2);
      standWasEl.style.display = '';
    } else {
      standWasEl.style.display = 'none';
    }
  }
  if (HAS_CLIPS) {
    const clipColor = clipOf(state.clip), clipShown = clipColor || CLIP_COLORS[0];
    document.getElementById('pickClip').textContent = clipColor ? clipColor.name : 'Not added';
    document.getElementById('clipPrice').innerHTML = `+$${clipShown.price.toFixed(2)} / each${wasInline(clipShown.compare, clipShown.price)}`;
  }

  /* Cart: one flat list for a single watch with nothing extra, as before;
     grouped by watch as soon as there is more than one thing to group. */
  const perWatch = watches.map((w, i) => watchLines(w, i, plan));
  const xLines = extraLines(plan);
  const total = perWatch.reduce((s, ls) => s + sumLines(ls), 0) + sumLines(xLines);
  let html;
  if (watches.length === 1 && !xLines.length) {
    html = perWatch[0].map(lineHtml).join('');
  } else {
    html = watches.map((w, i) => `
      <div class="cart-group">
        <div class="cart-group-head">
          <span>${escapeHtml(watchLabel(w, i))}${watches.length > 1 && i !== active
            ? `<button class="cg-edit" type="button" onclick="switchWatch(${i}); scrollToSection('secColor')">Edit</button>` : ''}</span>
          <span>$${sumLines(perWatch[i]).toFixed(2)}</span>
        </div>
        ${perWatch[i].map(lineHtml).join('')}
      </div>`).join('')
    + (xLines.length ? `
      <div class="cart-group">
        <div class="cart-group-head"><span>Extras</span><span>$${sumLines(xLines).toFixed(2)}</span></div>
        ${xLines.map(lineHtml).join('')}
      </div>` : '');
  }
  document.getElementById('cartLines').innerHTML = html;

  const totalStr = '$' + total.toFixed(2);
  document.getElementById('barTotal').textContent      = totalStr;
  document.getElementById('inlineTotal').textContent   = totalStr;
  document.getElementById('cartTotalLine').textContent = totalStr;
}

/* ============================================================
   CHECKOUT: every watch and every extra, merged into quantities per variant
   ============================================================ */
function buildCartItems() {
  const qty = new Map(), unmapped = [];
  const add = (id, label, n = 1) => {
    if (id) qty.set(id, (qty.get(id) || 0) + n);
    else unmapped.push(n > 1 ? `${label} × ${n}` : label);
  };
  const V = SHOPIFY_VARIANTS;
  watches.forEach((w, i) => {
    const tag = watches.length > 1 ? ` (${watchLabel(w, i)})` : '';
    const c = COLORS.find(x => x.id === w.color);
    add(V.watch, WATCH_NAME + tag);
    if (w.color !== 'b') add(V.bands && V.bands[w.color], `${c.name} ${c.fit} band${tag}`);
    const prot = protectorOf(w.protector);
    if (prot && prot.hex) add(V.protectors && V.protectors[w.protector], `${prot.name} screen protector${tag}`);
    if (w.charging === 'stand') add(V.stand, 'Charging Stand' + tag, w.standQty || 1);
    const clip = clipOf(w.clip);
    if (clip) add(V.clips && V.clips[w.clip], `Explorer Clip · ${clip.name}${tag}`);
  });
  for (const [kind, K] of Object.entries(EXTRA_KINDS)) {
    for (const it of K.items()) {
      const n = extras[kind][it.id] || 0;
      if (n) add(K.variant(it.id), K.line(it), n);
    }
  }
  return { items: [...qty].map(([id, quantity]) => ({ id, quantity })), unmapped };
}

/* ---------- remember the build (this browser only) ---------- */
function saveBuild() {
  try { localStorage.setItem(SAVE_KEY, JSON.stringify({ watches, active, extras })); } catch (e) {}
}
function restoreBuild() {
  try {
    const saved = JSON.parse(localStorage.getItem(SAVE_KEY) || 'null');
    if (!saved || !Array.isArray(saved.watches) || !saved.watches.length) return;
    const has = (list, id) => list.some(x => x.id === id);
    const clean = saved.watches.slice(0, MAX_WATCHES).map(w => {
      const n = newWatch();
      n.name = typeof w.name === 'string' ? w.name.slice(0, 18) : '';
      if (has(COLORS, w.color)) n.color = w.color;
      if (HAS_PROTECTORS && has(PROTECTORS, w.protector)) n.protector = w.protector;
      if (has(CHARGING, w.charging)) n.charging = w.charging;
      n.standQty = Math.max(1, Math.min(9, w.standQty | 0 || 1));
      if (HAS_CLIPS && w.clip && has(CLIP_COLORS, w.clip)) n.clip = w.clip;
      return n;
    });
    watches = clean;
    active = Math.min(Math.max(0, saved.active | 0), watches.length - 1);
    for (const kind of Object.keys(EXTRA_KINDS)) {
      const ids = EXTRA_KINDS[kind].items().map(it => it.id);
      const src = (saved.extras && saved.extras[kind]) || {};
      for (const id of ids) {
        const q = Math.max(0, Math.min(9, src[id] | 0));
        if (q) extras[kind][id] = q;
      }
    }
  } catch (e) { /* start fresh */ }
}

/* ---------- toast ---------- */
let toastTimer = 0;
function toast(msg, actionLabel, action) {
  const el = document.getElementById('cfgToast');
  el.innerHTML = `<span>${escapeHtml(msg)}</span>` + (actionLabel ? `<button type="button">${actionLabel}</button>` : '');
  if (actionLabel) el.querySelector('button').onclick = () => { el.classList.remove('is-on'); action(); };
  el.classList.add('is-on');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => el.classList.remove('is-on'), actionLabel ? 6000 : 3200);
}

/* ============================================================
   SHOPIFY — nothing exists yet. Fill these in when the Pro is
   published and loadLivePrices() below starts returning data.
   ============================================================ */
const SHOPIFY_DOMAIN  = 'cosmotogether.com';
const SHOPIFY_HANDLES = HOST.handles || { watch:null, bands:null, stand:null };
const SHOPIFY_VARIANTS = HOST.variants || {
  watch: null,
  bands:      { b:null, bl:null, g:null, p:null, t:null, bv:null, l:null, r:null, rb:null, y:null },
  stand:      null,
};

/* ============================================================
   STAGE: band x bumper render, or an accessory shot for its section
   ============================================================ */
/* Renders are named {band}-{bumper}; this build never adds a bumper. */
function watchSrc(color = state.color) {
  return asset(`configurator/${color}-none.webp`);
}
/* The Charging Stand stage is a nightstand scene per band x bumper combo
   (configurator/stand/{band}-{bumper}.webp, made by tools/make_stand_renders.py),
   so the stand always shows the watch the shopper has built. */
function standSrc(color = state.color) {
  return asset(`configurator/stand/${color}-none.webp`);
}
function currentSrc() {
  if (state.viewMode === 'stand') return standSrc();
  return watchSrc();
}

function heroAlt() {
  const c = COLORS.find(x => x.id === state.color);
  return `JrTrack Pro with a ${c.name} ${c.fit} band`
    + (state.viewMode === 'stand' ? ' on the Charging Stand' : '');
}

/* Fetch the next render BEFORE fading, so a swap never flashes an empty card
   on a slow connection. A newer pick cancels an older in-flight one. */
let heroToken = 0;
function updateHeroImage() {
  const img = document.getElementById('heroImg');
  const src = currentSrc();
  const scene = state.viewMode === 'stand';
  img.alt = heroAlt();
  if (img.getAttribute('src') === src) return;
  const token = ++heroToken;
  const next = new Image();
  const loaded = new Promise(done => { next.onload = next.onerror = () => done(); });
  next.src = src;
  /* decode() can stall indefinitely in a background tab or headless browser, which
     left the stage stuck on the old render. Take whichever comes first: decoded,
     or loaded plus a short grace for the decode to land. */
  const decoded = next.decode ? next.decode().catch(() => {}) : loaded;
  const ready = Promise.race([decoded, loaded.then(() => new Promise(r => setTimeout(r, 250)))]);
  ready.then(() => {
    if (token !== heroToken) return;
    img.style.opacity = '0';
    setTimeout(() => {
      if (token !== heroToken) return;
      img.src = src;
      img.classList.toggle('is-scene', scene);
      img.style.opacity = '1';
    }, 180);
  });
}

/* Warm the renders a tap away: on hover/touch of a swatch, and once idle, the
   other bumpers for the current band (they sit side by side, so people run
   through them). Each render is ~115 KB. */
const warmed = new Set();
function warm(src) {
  if (warmed.has(src)) return;
  warmed.add(src);
  const i = new Image(); i.src = src;
}
function warmBandRow() {
  const idle = window.requestIdleCallback || (fn => setTimeout(fn, 400));
  idle(() => {
    if (state.charging === 'stand') warm(standSrc());   // shown again on scroll to Charging
  });
}

/* ============================================================
   RENDERERS
   ============================================================ */
function wasInline(compareAt, price) {
  return (compareAt != null && compareAt > price + 0.001)
    ? ` <span class="was-inline">$${compareAt.toFixed(2)}</span>` : '';
}
function checkSvg() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
}
function plusSvg() {
  return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
}

function renderColors() {
  document.getElementById('colorGrid').innerHTML = COLORS.map(c => {
    const special = c.id === 'rb' ? 'is-rainbow' : c.id === 'y' ? 'is-sunrise' : '';
    const dotStyle = special ? '' : `background:${c.hex}`;
    return `
      <button class="swatch-btn ${state.color===c.id?'is-active':''}"
              onclick="pickColor('${c.id}')" onpointerenter="warm(watchSrc('${c.id}'))"
              title="${c.name} · ${c.fit}" type="button">
        <div class="swatch-ring ${state.color===c.id?'is-active':''}">
          <div class="swatch-dot ${special}" style="${dotStyle}"></div>
        </div>
        <div class="swatch-label">${c.name}</div>
        <div class="swatch-fit">${c.fit}</div>
      </button>`;
  }).join('');
}

function renderCharging() {
  document.getElementById('chargingCards').innerHTML = CHARGING.map(o => {
    const sel = state.charging === o.id;
    const standFree = FREE_STAND_OFFER && o.id === 'stand' && o.price > 0;
    const priceStr = standFree
      ? 'FREE'
      : o.price === 0
        ? 'Included'
        : `+$${o.price.toFixed(2)} / each${wasInline(o.compare, o.price)}`;
    const priceClass = standFree ? 'is-free' : (o.price > 0 ? 'is-paid' : '');
    return `
      <div class="chg-card ${sel?'is-active':''}" onclick="pickCharging('${o.id}')"${o.id === 'stand' ? ' onpointerenter="warm(standSrc())"' : ''}>
        <div class="chg-radio"></div>
        <div class="chg-info">
          <div class="chg-title">${o.title}</div>
          <div class="chg-desc">${o.desc}</div>
        </div>
        <div class="chg-price ${priceClass}">${priceStr}</div>
      </div>`;
  }).join('');
  decorateCharging();
}


/* ============================================================
   PICKERS
   ============================================================ */
function pickColor(id) {
  state.color = id;
  state.viewMode = 'watch';
  commitWatch();
  updateHeroImage();
  renderColors();
  renderWatchUI();
  syncSummary();
  update3dAvailability();
  applyBand3dColor();
  warmBandRow();
}

function pickCharging(id) {
  state.charging = id;
  state.viewMode = id === 'stand' ? 'stand' : 'watch';
  if (state.viewMode !== 'watch' && is3dActive) exit3d();
  commitWatch();
  updateHeroImage();
  renderCharging();
  update3dAvailability();
  renderWatchUI();
  syncSummary();
}

/* ============================================================
   INLINE 3D VIEWER
   ============================================================ */
let viewer3dLoaded = false;
let band3dReady    = false;
let is3dActive     = false;
let dressed3d      = Promise.resolve();   // settles once the loaded model wears the current build

function toggle3d() { if (!is3dActive) enter3d(); else exit3d(); }

function enter3d() {
  const inline = document.getElementById('viewer3dInline');
  const btn    = document.getElementById('view3dBtn');
  const mv     = document.getElementById('jtpromv');
  is3dActive = true;

  if (!viewer3dLoaded) {
    viewer3dLoaded = true;
    /* Drop the layout-suppressing class first so the container has real
       dimensions before model-viewer measures its canvas. */
    inline.classList.remove('is-off-init');
    void inline.offsetWidth;
    const s = document.createElement('script');
    s.type = 'module';
    s.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';
    document.head.appendChild(s);
    // Fires when the model finishes loading.
    mv.addEventListener('load', () => { band3dReady = true; dressed3d = apply3dFinish(); });
    init3dControls();
  }
  /* Keep the photo up until the model is dressed: band color, case finish and,
     slowest, the watch face that matches the band. Revealing on load showed
     the GLB's own orange face for a beat before it swapped. */
  const waitModel = band3dReady
    ? Promise.resolve()
    : new Promise(r => mv.addEventListener('load', r, { once: true }));
  sync3dModel();
  btn.classList.add('is-loading');
  const dressedNow = waitModel.then(() => dressed3d);
  const timeout = new Promise(r => setTimeout(r, 6000));   // never leave the shopper waiting on a slow texture
  Promise.race([dressedNow, timeout]).catch(() => {}).then(() => {
    btn.classList.remove('is-loading');
    /* Fade in next frame — but rAF is throttled to a stop in a backgrounded tab,
       so a timer backs it up and the viewer can never get stuck invisible. */
    const reveal = () => { if (is3dActive) inline.classList.add('is-on'); };
    requestAnimationFrame(reveal);
    setTimeout(reveal, 120);
  });
  inline.setAttribute('aria-hidden', 'false');
  btn.classList.add('is-active');
  btn.style.setProperty('background-color', themeToken('--pill-bg-active'), 'important');
  syncView3dIcons();
  syncView3dLabel();
}

function exit3d() {
  const inline = document.getElementById('viewer3dInline');
  const btn    = document.getElementById('view3dBtn');
  is3dActive = false;
  btn.classList.remove('is-loading');
  inline.classList.remove('is-on');
  inline.setAttribute('aria-hidden', 'true');
  btn.classList.remove('is-active');
  btn.style.setProperty('background-color', themeToken('--pill-bg'), 'important');
  syncView3dIcons();
  syncView3dLabel();
}

/* jtpro.glb materials: body, screen, bezel, button_sos, button, contact_gold,
   band-silicone, display_on, grill_backing, protector-tint, protector-glass.
   Configurable here: band color. The protector ships transparent and stays hidden. */
/* ============================================================
   BAND FINISH: studio lighting (environment-image above) + baked AO.
   model-viewer never shadows a model onto itself, so the inside of the loop
   and the strap tucked under the case were lit as brightly as the outside,
   which read as flat. jtpro-band-ao.bin holds one occlusion value per band
   vertex (cad/lighting/bake_ao.py), applied as vertex colors that multiply
   the band color at 60% strength. Silicone also gets a little more sheen
   (roughness 0.7 -> 0.5). The case reads as bead-blasted aluminum (mostly
   metal, soft satin sheen) and the SOS button as a saturated orange; see
   CASE_FINISH.

   The AO is tied to jtpro.glb's exact geometry. If the GLB changes, re-bake
   (see cad/lighting/). On any mismatch this quietly does nothing and the
   band just renders without AO.
   ============================================================ */
const BAND_AO_URL = asset('3d/jtpro-band-ao.bin');
const BAND_ROUGHNESS = 0.5;
/* Case finish, set absolutely so re-running can't compound. Body and bezel are
   bead-blasted aluminum: more metallic than the GLB (0.62 / 0.55) with a softer,
   satin sheen (roughness 0.38 / 0.30 -> 0.46 / 0.42). A dark base reflects less
   once it's mostly metal, so the color is lifted to keep the charcoal of the
   product renders. The SOS button gets a more saturated orange than the GLB's
   (0.855, 0.42, 0.09), which displays as a pale peach. Colors here are linear. */
const CASE_FINISH = {
  body:       { color: [0.200, 0.210, 0.230, 1], metal: 0.90, rough: 0.52 },
  bezel:      { color: [0.125, 0.132, 0.150, 1], metal: 0.85, rough: 0.48 },
  button_sos: { color: [0.930, 0.220, 0.012, 1], metal: 0.05, rough: 0.48 },   // linear; about #F78118 on screen
};

async function applyBandFinish() {
  const mv = document.getElementById('jtpromv');
  if (!mv || !mv.model) return;
  const band = mv.model.materials.find(m => m.name === 'band-silicone');
  if (band) band.pbrMetallicRoughness.setRoughnessFactor(BAND_ROUGHNESS);
  for (const [name, f] of Object.entries(CASE_FINISH)) {
    const mat = mv.model.materials.find(m => m.name === name);
    if (!mat) continue;
    mat.pbrMetallicRoughness.setBaseColorFactor(f.color);
    mat.pbrMetallicRoughness.setMetallicFactor(f.metal);
    mat.pbrMetallicRoughness.setRoughnessFactor(f.rough);
  }
  try {
    const ao = new Uint8Array(await (await fetch(BAND_AO_URL)).arrayBuffer());
    // model-viewer 3.5 has no public vertex-color API, so reach its three.js
    // scene through the element's internal 'scene' symbol (version is pinned).
    const sym = Object.getOwnPropertySymbols(mv).find(s => s.description === 'scene');
    if (!sym) return;
    const meshes = [];
    mv[sym].traverse(o => { if (o.isMesh && o.material && o.material.name === 'band-silicone') meshes.push(o); });
    meshes.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));   // band_1..band_9 = GLB primitive order
    const total = meshes.reduce((n, o) => n + o.geometry.attributes.position.count, 0);
    if (!meshes.length || total !== ao.length) return;
    let off = 0;
    for (const o of meshes) {
      const n = o.geometry.attributes.position.count, col = new Float32Array(n * 3);
      for (let i = 0; i < n; i++) col[i * 3] = col[i * 3 + 1] = col[i * 3 + 2] = ao[off + i] / 255;
      off += n;
      const BufferAttribute = o.geometry.attributes.position.constructor;   // three's class, no THREE global here
      o.geometry.setAttribute('color', new BufferAttribute(col, 3));
      o.material.vertexColors = true;
      o.material.needsUpdate = true;
    }
  } catch (e) { /* no AO; the band still renders */ }
}

function applyBand3dColor() {
  const mv = document.getElementById('jtpromv');
  if (!mv || !mv.model) return;
  const band = mv.model.materials.find(m => m.name === 'band-silicone');
  if (!band) return;
  const c = COLORS.find(x => x.id === state.color);
  if (c && c.hex) band.pbrMetallicRoughness.setBaseColorFactor(c.hex);
}

/* The screen protector (bumper + tempered glass) is built into the GLB from the
   C6-SHELL STEP. This build sells no protector, so keep both materials invisible. */
function applyProtector3d() {
  const mv = document.getElementById('jtpromv');
  if (!mv || !mv.model) return;
  const tint  = mv.model.materials.find(m => m.name === 'protector-tint');
  const glass = mv.model.materials.find(m => m.name === 'protector-glass');
  if (!tint || !glass) return;
  tint.setAlphaMode('BLEND');
  tint.pbrMetallicRoughness.setBaseColorFactor([0, 0, 0, 0]);
  glass.pbrMetallicRoughness.setBaseColorFactor([0, 0, 0, 0]);
}

/* The GLB carries the Active-Fit silicone band only, and Comfort/Stretch fits are
   woven, so 3D would misrepresent them. Hide the toggle; the render is the truth. */
function update3dAvailability() {
  const c = COLORS.find(x => x.id === state.color);
  const has3d = !!c && c.fit === 'Active-Fit' && state.viewMode === 'watch';
  const btn = document.getElementById('view3dBtn');
  btn.classList.toggle('is-hidden', !has3d);
  if (!has3d && is3dActive) exit3d();
  else if (is3dActive) sync3dModel();
}

/* One model (jtpro.glb). The camera orbits the middle of the band loop; see the
   camera-orbit / camera-target attributes on <model-viewer>. */
function sync3dModel() {
  const mv = document.getElementById('jtpromv');
  if (!viewer3dLoaded || !mv) return;
  if (!mv.getAttribute('src')) mv.setAttribute('src', mv.dataset.src);
  else if (band3dReady) dressed3d = apply3dFinish();
}

function apply3dFinish() {
  applyBand3dColor();
  applyBandFinish();
  applyProtector3d();
  return applyFace3d();   // the face texture is the slow part; callers can wait on it
}

/* Watch face matches the band, the same
   way the product photos do. Faces are built by cad/make_face_textures.py from
   Eric's face art: same black border, notch and lens as the shipped orange face,
   so they drop onto the display's UVs unchanged. ~35 KB each, fetched on demand. */
const faceUrl = face => asset(`3d/faces/${face}.webp`);
let faceToken = 0;
const faceShown = new WeakMap();   // display material -> face currently on it (per loaded model)
async function applyFace3d() {
  const mv = document.getElementById('jtpromv');
  if (!mv || !mv.model || !mv.createTexture) return;
  const mat = mv.model.materials.find(m => m.name === 'display_on');
  if (!mat || !mat.emissiveTexture) return;
  const face = (COLORS.find(x => x.id === state.color) || COLORS[0]).face;
  if (faceShown.get(mat) === face) return;
  const token = ++faceToken;
  try {
    const tex = await mv.createTexture(faceUrl(face));
    if (token !== faceToken || !mv.model) return;          // a newer pick won
    mat.emissiveTexture.setTexture(tex);
    faceShown.set(mat, face);
  } catch (e) { /* keep whatever face is showing */ }
}

function init3dControls() {
  const mv = document.getElementById('jtpromv');
  const hint = document.getElementById('cosmo3dHint');
  mv.addEventListener('camera-change', e => {
    if (e.detail.source === 'user-interaction' && hint) hint.classList.add('cosmo3d-hidden');
  });
}

function syncView3dIcons() {
  const cube  = document.querySelector('.view3d-ic-cube');
  const photo = document.querySelector('.view3d-ic-photo');
  if (!cube || !photo) return;
  cube.style.setProperty('display',  is3dActive ? 'none' : 'block', 'important');
  photo.style.setProperty('display', is3dActive ? 'inline-block' : 'none', 'important');
}

function syncView3dLabel() {
  const el = document.getElementById('view3dLabel');
  if (!el) return;
  const m = window.matchMedia('(max-width: 820px), (max-width: 1080px) and (orientation: portrait)').matches;
  el.textContent = is3dActive ? (m ? 'Photo' : 'View photo') : (m ? '3D' : 'View in 3D');
}
window.addEventListener('resize', syncView3dLabel);

/* GemPages resets button box styling from a cascade layer, which beats any
   unlayered rule. Inline !important sits above all layers. No-op standalone. */
function themeToken(name) {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

/* The Hearth logotype is brown ink, which disappears on the dark nav. */
function applyThemeAssets() {
  const logo = document.getElementById('navLogo');
  if (!logo) return;
  const dark = document.documentElement.getAttribute('data-theme') === 'dark';
  logo.src = asset(`brand/Cosmo_Logotype_${dark ? 'White' : 'Hearth'}.svg`);
}

function armorButtons() {
  const set = (el, props) => { if (!el) return; for (const k in props) el.style.setProperty(k, props[k], 'important'); };
  set(document.getElementById('view3dBtn'), { 'background-color': themeToken('--pill-bg'), 'padding': '10px 16px' });
  syncView3dIcons();
  syncView3dLabel();
}

/* ============================================================
   CHECKOUT — refuses until the Pro exists in Shopify
   ============================================================ */
function handleCheckoutTap() { handleCart(); }

function openReview() {
  document.getElementById('reviewLines').innerHTML = document.getElementById('cartLines').innerHTML;
  const total = document.getElementById('barTotal').textContent;
  document.getElementById('reviewTotal').textContent = total;
  document.getElementById('reviewCartTotal').textContent = total;
  document.getElementById('reviewBackdrop').classList.add('is-open');
  document.getElementById('reviewSheet').classList.add('is-open');
}
function closeReview() {
  document.getElementById('reviewBackdrop').classList.remove('is-open');
  document.getElementById('reviewSheet').classList.remove('is-open');
}

let checkoutSubmitting = false;
const checkoutBtnHtml = new WeakMap();

function checkoutButtons() {
  return [...document.querySelectorAll('.btn-cart')];
}

function setCheckoutLoading(on) {
  checkoutButtons().forEach(btn => {
    if (on) {
      if (!checkoutBtnHtml.has(btn)) checkoutBtnHtml.set(btn, btn.innerHTML);
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = '<span class="btn-spinner" aria-hidden="true"></span>Checking out\u2026';
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (checkoutBtnHtml.has(btn)) btn.innerHTML = checkoutBtnHtml.get(btn);
    }
  });
  if (!on) syncSummary();
}

async function handleCart() {
  if (checkoutSubmitting) return;
  const { items, unmapped } = buildCartItems();
  if (!SHOPIFY_VARIANTS.watch) {
    alert(WATCH_NAME + ' is not in Shopify yet, so there is nothing to check out.\n\n'
      + 'Your build:\n· ' + unmapped.join('\n· ')
      + '\n\nAdd the real variant IDs in the Shopify section settings to switch checkout on.');
    return;
  }
  if (unmapped.length) {
    alert('Heads up: no Shopify SKU exists yet for:\n· ' + unmapped.join('\n· ') + '\n\nThose items were skipped.');
  }
  if (!items.length) return;
  checkoutSubmitting = true;
  setCheckoutLoading(true);
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error('add.js ' + res.status);
    window.location.href = '/checkout';
  } catch (e) {
    window.open(`https://${SHOPIFY_DOMAIN}/cart/` + items.map(i => `${i.id}:${i.quantity}`).join(','), '_blank');
    checkoutSubmitting = false;
    setCheckoutLoading(false);
  }
}

addEventListener('pageshow', (e) => {
  if (!e.persisted && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
  checkoutSubmitting = false;
  setCheckoutLoading(false);
});

/* ============================================================
   SCROLL BEHAVIOUR
   ============================================================ */
function initReveal() {
  const targets = [...document.querySelectorAll('.cfg-section, .cfg-header')];
  const io = new IntersectionObserver(
    entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
    { threshold: 0.06 }
  );
  targets.forEach(el => io.observe(el));

  /* Sections start at opacity 0, so if the observer never runs the whole panel
     stays blank. It doesn't run in a backgrounded tab, and some embeds suppress
     it entirely. If nothing has revealed by now, IO is not coming — show
     everything. Guarded on "nothing revealed" so the normal scroll-in animation
     is untouched wherever IO does work. */
  setTimeout(() => {
    if (targets.some(el => el.classList.contains('visible'))) return;
    targets.forEach(el => el.classList.add('visible'));
  }, 1200);
}

/* Which section is "being read": the one crossing a line near the top of the
   readable area. Works in both layouts (desktop scrolls .cfg-panel, mobile
   scrolls the page with the hero pinned). */
function activeSectionId() {
  const imgPanel = document.querySelector('.img-panel');
  const stacked = isStacked();
  const top = stacked ? imgPanel.getBoundingClientRect().bottom : 0;
  const line = top + (window.innerHeight - top) * 0.30;

  let containing = null, nearest = null, nearestDist = Infinity;
  for (const s of document.querySelectorAll('.cfg-section')) {
    const r = s.getBoundingClientRect();
    if (r.top <= line && r.bottom >= line) containing = s;
    const d = Math.min(Math.abs(r.top - line), Math.abs(r.bottom - line));
    if (d < nearestDist) { nearestDist = d; nearest = s; }
  }
  return (containing || nearest)?.id || null;
}

/* The section you're reading drives the stage, exactly as on the JT5 page. */
function syncSectionPreview() {
  if (is3dActive) return;
  const id = activeSectionId();
  let want = 'watch';
  if (id === 'secCharging' && state.charging === 'stand') want = 'stand';
  if (want === state.viewMode) return;
  state.viewMode = want;
  updateHeroImage();
  update3dAvailability();
}

function initSectionPreview() {
  const onScroll = () => syncSectionPreview();
  document.getElementById('cfgPanel').addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  const io = new IntersectionObserver(onScroll, {
    threshold: Array.from({ length: 21 }, (_, i) => i / 20),
  });
  document.querySelectorAll('.cfg-section').forEach(el => io.observe(el));
  syncSectionPreview();
}

/* Hand the sticky bar off to the inline button as it scrolls into view. */
function initStickyCta() {
  const inlineBtn = document.querySelector('.cart-inline .btn-cart-wide');
  const bar  = document.getElementById('summaryBar');
  const fade = document.getElementById('scrollFade');
  const io = new IntersectionObserver(
    entries => entries.forEach(e => {
      bar.classList.toggle('is-hidden', e.isIntersecting);
      fade.classList.toggle('is-hidden', e.isIntersecting);
    }),
    { root: null, rootMargin: '0px 0px -88px 0px', threshold: 0.4 }
  );
  io.observe(inlineBtn);
}

/* ============================================================
   LIVE PRICES: Shopify is the source of truth
   Every line item takes its price and compare-at from the Shopify variant it
   adds to the cart. The numbers at the top of this file are only a fallback
   for a variant that has no live price yet (pre-launch, or an unmapped color).
   Two sources, same shape ({ variantId: { price, compare } } in dollars):
     - HOST.livePrices: rendered server-side by the Shopify section, so the
       page paints with real prices and makes no extra request;
     - SHOPIFY_HANDLES: product handles fetched from /products/<handle>.js,
       for hosts on the store domain that can't render Liquid.
   ============================================================ */
function applyLivePrices(live) {
  const V = SHOPIFY_VARIANTS, unpriced = [];
  const get = (id, label) => {
    if (!id) return null;
    const hit = live[id] || live[String(id)];
    if (!hit) unpriced.push(label);
    return hit || null;
  };
  const w = get(V.watch, WATCH_NAME);
  if (w) { BASE_PRICE = w.price; BASE_COMPARE = w.compare; }
  COLORS.forEach(c => {
    const v = get(V.bands && V.bands[c.id], `${c.name} ${c.fit} band`);
    if (!v) return;
    c.unit = v.price; c.unitCompare = v.compare;                       // extra band
    if (c.bandPrice) { c.bandPrice = v.price; c.bandCompare = v.compare; }  // worn band (Black is included)
  });
  const stand = CHARGING.find(o => o.id === 'stand');
  const s = get(V.stand, 'Charging Stand');
  if (s) { stand.price = s.price; stand.compare = s.compare; }
  if (unpriced.length && Object.keys(live).length) {
    console.warn('[' + WATCH_NAME + '] variant ID set but no live price found (is its product picked?):', unpriced);
  }
  renderCharging();
  renderAllExtras();
  renderWatchUI();
  syncSummary();
}

function livePricesFromProduct(product, into) {
  (product && product.variants || []).forEach(v => {
    into[v.id] = { price: v.price / 100,
                   compare: v.compare_at_price != null && v.compare_at_price > v.price ? v.compare_at_price / 100 : null };
  });
  return into;
}

async function loadLivePrices() {
  if (HOST.livePrices) return applyLivePrices(HOST.livePrices);
  const handles = Object.values(SHOPIFY_HANDLES).flat().filter(Boolean);
  if (!handles.length) return;
  const live = {};
  await Promise.all(handles.map(h =>
    fetch(`/products/${h}.js`, { headers: { Accept: 'application/json' } })
      .then(r => r.ok ? r.json() : null).then(p => livePricesFromProduct(p, live)).catch(() => {})));
  applyLivePrices(live);
}

/* ---------- boot ---------- */
restoreBuild();
loadWatch(active);
renderColors();
renderCharging();
update3dAvailability();
armorButtons();
applyThemeAssets();
syncSummary();
initReveal();
initSectionPreview();
initStickyCta();
loadLivePrices();
warmBandRow();   // the stand scene for the starting band, if the stand is chosen
renderAllExtras();
renderWatchUI();
updateHeroImage();
